var _linearGradient, _linearGradient2, _radialGradient, _radialGradient2, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 484.48,
    x2: 536.14,
    y1: 319.34,
    y2: 785.87
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#123214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3e7c37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5fbb46"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(115.64 0 0 -355.9 -555713.76 -754599.8)",
    gradientUnits: "userSpaceOnUse",
    x1: 4812.32,
    x2: 4812.32,
    y1: -2121.07,
    y2: -2122.13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.42
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 1772.25,
    cy: -341.52,
    fy: -409.148898,
    gradientTransform: "matrix(1.17 .59 -.28 .47 -1527.13 -664.3)",
    gradientUnits: "userSpaceOnUse",
    r: 151.52
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fff",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 570.86,
    cy: 398.43,
    fx: 613.100178,
    fy: 841.347907,
    gradientTransform: "matrix(.76783646 .64064591 -.69830404 .83694174 410.75 -300.75)",
    gradientUnits: "userSpaceOnUse",
    r: 444.93
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 502.49,
    cy: 490.94,
    fill: "#50b651",
    r: 401.79
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m903.05 489.81c0 222.6-180.45 403.05-403 403.05s-403.05-180.45-403.05-403.05c0-98.47 2.76-113.11 41.52-169.17 0 0-2 63.32 44.43 101 28.87 23.41 59 6.51 114.15-18.89 59.66-27.5 108.16-45.24 146-40.56 57 7.06 232.69 112.57 324.38 91.56 73.25-16.75 65.52-189.45 65.52-189.45 80 78.12 70.05 130.92 70.05 225.51z",
    fill: "url(#a)",
    opacity: 0.663
  }), /*#__PURE__*/React.createElement("path", {
    d: "m673 785.86q218.65-205.67 72.69-471.24.74.54 18.06-62.32 77.68 94.07 82.61 232.22-.04 178.94-173.36 301.34z",
    fill: "url(#b)",
    opacity: 0.586
  }), /*#__PURE__*/React.createElement("path", {
    d: "m603.86 253.13c-70.36-38.94-151.08-117.27-140.35-133.72s150-13.62 220.37 25.32 130.26 155.75 119.54 172.2-129.2-24.86-199.56-63.8z",
    fill: "url(#c)",
    opacity: 0.744
  }), /*#__PURE__*/React.createElement("path", {
    d: "m665.15 589.89c-58.37 0-105.69-48.67-105.69-108.7s47.32-108.69 105.69-108.69 105.7 48.66 105.7 108.69-47.32 108.7-105.7 108.7zm.75-34.48c36.43 0 66-33.23 66-74.22s-29.57-74.19-66-74.19-66 33.23-66 74.21 29.57 74.2 66 74.2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.08 284.98h76.16v303.7h-41.81v-270.39h-34.35z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.32 375.59h39.53v253.62c0 23.11-24.31 47.18-48 57.54q-16.8 7.34-62 8.72v-25.23q44.21-4.93 59.68-19.67a59.29 59.29 0 0 0 10.8-28.06v-74.51q-15.85 33.63-39.92 44.59c-16.68 9-50.63 7.52-64.49 0s-34.19-27.32-43.51-56.81c-2.58-8.14-9-30.29-8.33-53.76.6-22.35 8-46 14.15-55.72 10.56-16.6 27.21-37.39 52.43-46.08q18.48-6.37 68.5-4.58v25.09q-37.17-2.51-46.38 2.51c-9.21 5-30 11.17-36.86 56.48s.2 82.39 21.95 94c7.45 4 20.63 8.73 32.81 4.56 23.4-8 45.42-36.53 47.1-55.86q2.54-29.42 2.54-126.83z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m890.42 570.48c-37.33 179.75-196.61 314.81-387.42 314.81-218.53 0-395.69-177.16-395.69-395.69 0-135.76 68.37-255.55 172.55-326.8-84.65 70.2-138.55 176.25-138.55 294.84 0 211.53 171.48 383 383 383 172.26 0 317.94-113.71 366.11-270.16z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503 21c-258.8 0-468.61 209.8-468.61 468.6s209.81 468.61 468.61 468.61 468.61-209.81 468.61-468.61-209.81-468.6-468.61-468.6zm0 864.3c-218.53 0-395.69-177.16-395.69-395.69 0-135.76 68.37-255.55 172.55-326.8a393.82 393.82 0 0 1 223.14-68.9c218.53 0 395.69 177.15 395.69 395.69a397.6 397.6 0 0 1 -8.27 80.88c-37.33 179.75-196.61 314.81-387.42 314.81z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlo);
export default __webpack_public_path__ + "static/media/glo.df48b1f67abbe804eb07eb89f3d5831d.svg";
export { ForwardRef as ReactComponent };